import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../../../Constant/slugs';
import { ImageURL, signInImage } from '../../../Constant/api';

export default function Dashboard2() {
	const data = [
		{
			slug: slugs.exam,
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/All-Exam.jpeg",
			text: "All Exam"
		},
		{
			slug: slugs.demo_exam,
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/Demo-Exam.jpeg",
			text: "Free Exam"
		},
		{
			slug: slugs.classroom,
			text: "ClassRoom",
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/Books.jpeg"
		},
		{
			slug: slugs.exam_result_list,
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/Exam-Result.jpeg",
			text: "Exam Result",
		},
		{
			slug: slugs.books,
			text: "Books",
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/Books.jpeg"
		},
		{
			slug: "/profile",
			text: "Profile",
			image: "https://api.kmsinstitutenepal.com/wp-content/uploads/2023/08/Books.jpeg"
		},
	]
	const Block = ({ slug, text }) => {
		return (
			<div className="col-lg-4 col-12" >
				<Link style={{
					textDecorationLine: 'none',
					display: 'flex',
					justifyContent: 'center',
					// color: "#000",
				}}
					to={`${slug}`}
				>
					<div
						className="home-box-2"
					>
						<img style={{ width: "100%" }}
							// style={{
							//     backgroundColor: "#fff", border: "1px solid black",
							//     width: "220px", height: "220px",
							//     borderRadius: "5px"
							//   }}
							src={signInImage}
						/>
						<div style={{ color: "#000", textAlign: "center", fontWeight: "bold" }}>{text}</div>
					</div>
				</Link>

			</div>
		)
	}
	return (
		<div>
			<div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 form-view mt-3">
						<div className="row" style={{ margin: "10px" }}>
							{data.map((item, index) => (
								<Block slug={item.slug} image={item.image} text={item.text} />
							))}
						</div>
					</div>
				</div>
			</div >
		</div >
	)
}